import styled, { css } from "styled-components";

export const StyledBondPreviewSection = styled.section``;

export const StyledBondPreviewButton = styled.button`
  width: 100%;
  font-size: 18px;
  color: white;
  border-radius: 5px !important;
  background-color: var(--primary);
  text-transform: uppercase !important;
  line-height: 18px;
  font-family: "Inter" !important;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
`;

export const StyledSpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -25px;
`;

export const StyledBondPreview = styled.button<{ isDisabled: boolean }>`
  display: block;
  width: 100%;
  padding: 12px 0;
  color: white !important;
  text-decoration: none !important;
  cursor: pointer;

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      cursor: not-allowed;
      pointer-events: none;
      opacity: 0.65;
    `}
`;

export const StyledPrice = styled.div`
  text-align: center;
  font-size: 32px;
  color: var(--primary);
  margin-bottom: 50px;
`;

export const StyledButtonsWrapper = styled.div`
  color: var(--primary);
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 40px;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;

  @media only screen and (max-width: 920px) {
    justify-content: center;
  }
`;

export const StyledDownloadButton = styled.button<{ isDisabled?: boolean }>`
  width: 100%;
  font-size: 32px;
  color: var(--primary) !important;
  border: 2px solid var(--primary) !important;
  font-size: 16px;
  line-height: 18px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 11px 0;
  font-family: "Inter" !important;
  cursor: pointer;

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      pointer-events: none;
      opacity: 0.65;
    `}
`;

export const StyledPriceWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  width: fit-content;
  margin: 0 auto;
  column-gap: 10px;
  row-gap: 5px;
  margin-bottom: 50px;
  font-family: "Inter";
`;

export const StyledPriceValue = styled.div`
  text-align: left;
  font-size: 32px;
  line-height: 32px;
  color: var(--text);
`;

export const StyledPriceLabel = styled(StyledPriceValue)`
  text-align: right;
`;

export const StyledBorder = styled.div`
  grid-column: 1 / -1;
  height: 2px;
  background: var(--primary);
`;
